import { render, staticRenderFns } from "./ProfileSetup.vue?vue&type=template&id=7ec7ba8a&scoped=true&"
import script from "./ProfileSetup.vue?vue&type=script&lang=js&"
export * from "./ProfileSetup.vue?vue&type=script&lang=js&"
import style0 from "./ProfileSetup.vue?vue&type=style&index=0&id=7ec7ba8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec7ba8a",
  null
  
)

export default component.exports